export const tinyAnalyticsContent = `# Tiny Analytics Quickstart

Instantly see how many people are using your app, track daily signups, and monitor usage trends with Lightswitch. No cookies, no banners, no hassle—just drop it in and go.

Note: You will need to set up an account with Lightswitch to obtain the following:

- App Slug
- Publishable API Key

This guide will set you up.

---

## 1. Install the SDK

\`\`\`bash
npm install @lightswitch-sdk/lightswitch-sdk-js
\`\`\`

---

## 2. Initialize the Provider

Wrap your app with the LightswitchProvider:

\`\`\`jsx
import { LightswitchProvider } from '@lightswitch-sdk/lightswitch-sdk-js';

function App() {
  return (
    <LightswitchProvider publishableKey="YOUR_PUBLISHABLE_KEY" appSlug="your-app-slug">
      <YourApp />
    </LightswitchProvider>
  );
}
\`\`\`

---

## 3. Track an Event

Use the \`useLightswitch\` hook to track events anywhere in your app:

\`\`\`jsx
import { useLightswitch } from '@lightswitch-sdk/lightswitch-sdk-js';

function SignupButton() {
  const { trackEvent } = useLightswitch();

  const handleSignup = () => {
    // ... your signup logic ...
    trackEvent('signup'); // Track a signup event
  };

  return <button onClick={handleSignup}>Sign up</button>;
}
\`\`\`

You can track any event (e.g. \`pageview\`, \`login\`, \`purchase\`) by changing the event name.

---

## That's it! Just install, wrap, track, and watch your stats.`; 